/* cspell:words refulfilled refulfillment */
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

const RmrRefulfillmentMetrics_ = z.object({
  itemsRefulfilledLast30d: z.number(),
  refulfilledValueCents: z.number(),
});
export const RmrRefulfillmentMetrics: z.ZodType<RmrRefulfillmentMetrics> =
  RmrRefulfillmentMetrics_;
export interface RmrRefulfillmentMetrics
  extends z.infer<typeof RmrRefulfillmentMetrics_> {}

export const getRmrRefulfillmentMetrics = unaryRpc({
  name: "getRmrRefulfillmentMetrics" as const,
  input: z.object({ teamId: z.string() }),
  output: RmrRefulfillmentMetrics,
});
